import React, {useEffect, useState} from "react";
import EditableTable from "../../../primer/Editable-Table";
import {clientsCategoryData} from '../../../../_data/clients/clients-settings';
import Input from '../../../common/Input';
import {setEditing} from "../../../../_reducers/activitySlice";
import {useDispatch, useSelector} from "react-redux";
import {
    resetClientNewCategory,
    setClientNewCategory,
    setClientsSettings, setSelectedClientCategory
} from "../../../../_reducers/DataPanel/Clients/clientSlice";
import {fetchClientsSettings, postClientsSettings} from "../../../../_apis/api";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {
    checkPermission,
    getLastHighestValue,
    getMaskCode,
    getMaskCodePrefix,
    leadingZeros
} from "../../../../_helpers/commonFunctions";
import {Popconfirm} from "antd";
import {toast} from "react-toastify";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import LogTable from "../../../primer/LogTable";
import {useTranslation} from "../../../../hooks/useTranslation";
import TagManager from "../../../primer/TagManager/TagManager";

const ClientsSettings = () => {
    const {t} = useTranslation();
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const company = useSelector(state => state.COMPANY_DATA.company)
    const dispatch = useDispatch();
    const [infoNewField, setInfoNewField] = useState('')
    const [clientsInfoInput, setClientsInfoInput] = useState('');
    const selectedCategory = useSelector((state) => state.CLIENTS_DATA.selectedClientCategory);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const [loadingApplyToAll, setLoadingApplyToAll] = useState(false);
    const [showApplyToAll, setShowApplyToAll] = useState(false);

    const clientsColumns = [
        {
            name: t('ProductsSettings.smallTable.categoryName'),
            field: "category",
            width: "200px",
            editable: true,
            disabled: true,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t('ProductsSettings.smallTable.codeMask'),
            field: "maskCode",
            width: "100px",
            editable: true,
            mask: true,
            inputType: {
                type: 'text',
            }
        },
    ];
    const requestData = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active"
    }

    useEffect(() => {
        dispatch(fetchClientsSettings(requestData))
    }, [])

    const handleOnChange = (e, type = "default", ddname = '') => {
        // Set if editing the form
        if (!ACTIVITY.editing) {
            dispatch(setEditing(true));
        }
        let name;
        let value;
        if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        // Set settings data
        let newSettings = Object.assign({}, CLIENTS_DATA.clientsSettings);
        let newSettingsData = {};
        newSettingsData[name] = value;
        newSettings = {...newSettings, ...newSettingsData}
        dispatch(setClientsSettings(newSettings));
    }

    const handeKeyDown = (e) => {
        // Add client info on enter
        if (e.key === 'Enter') {
            const value = e.target.value;
            if (!value || value.length === 0) return;
            dispatch(setClientsSettings(infoNewField));
            setClientsInfoInput(''); // clear new input value
        }
    }

    const addInfoField = () => {
        dispatch(setClientsSettings(infoNewField));
        setClientsInfoInput(''); // clear new input value
    }

    const setInputToState = (e, type = "default", ddname = '') => {
        if (!ACTIVITY.editing) dispatch(setEditing(true));

        let name;
        let value;

        if (type === 'dd') {
            name = ddname;
            value = e.value;
        } else {
            name = e.target.name;
            value = e.target.value;
        }

        setClientsInfoInput(value); // set input value

        // Set Input Data to State
        let newSettings = Object.assign({}, CLIENTS_DATA.clientsSettings);
        let newSettingsData = {};
        let clientsInfo = newSettings.clientsInfo.slice();
        clientsInfo.push(value);
        newSettingsData[name] = clientsInfo;
        newSettings = {...newSettings, ...newSettingsData}
        setInfoNewField(newSettings);
    }

    const handleOnClientInfoChange = () => {}

    const deleteInfoField = (label, index) => {
        let oldClientSettings = Object.assign({}, CLIENTS_DATA.clientsSettings);
        let oldClientInfo = oldClientSettings.clientsInfo;
        if (index > -1) {
            oldClientInfo = oldClientInfo.filter(item => item !== label)
        }
        dispatch(setClientsSettings({...oldClientSettings, clientsInfo: oldClientInfo}));
        dispatch(setEditing(true));
    }

    const parentActions = {
        insert: (e, data) => {
            dispatch(setEditing(true));
            let tempNewCategory = Object.assign({}, CLIENTS_DATA.newCategory);
            if (e.key !== "Enter") {
                if (data.field === 'maskCode') {
                    tempNewCategory[data.field] = getMaskCode(data.value);
                    tempNewCategory['maskCodePrefix'] = getMaskCodePrefix(data.value);
                    tempNewCategory['mask'] = data.value;
                } else {
                    tempNewCategory[data.field] = data.value;
                    // tempNewCategory['maskCode'] = `PCM-${categoryData.length + 1}`;
                }
                dispatch(setClientNewCategory(tempNewCategory)); // Update redux new category state

                // On Value Enter
                if (tempNewCategory.category !== "" && tempNewCategory.maskCode !== "") {
                    let updateNewCategory = Object.assign({}, CLIENTS_DATA.newCategory);
                    const lastVal = getLastHighestValue(CLIENTS_DATA.categories, 'maskCodeCounter') + 1;
                    updateNewCategory.maskCode = tempNewCategory.maskCode;
                    updateNewCategory.mask = getMaskCodePrefix(data.value) + '-' + leadingZeros(lastVal, 4);
                    updateNewCategory.maskCodePrefix = getMaskCodePrefix(data.value);
                    updateNewCategory._id = getLastHighestValue(CLIENTS_DATA.categories, '_id') + 1;
                    updateNewCategory.maskCodeCounter = lastVal;

                    dispatch(setClientsSettings({
                        ...CLIENTS_DATA.clientsSettings,
                        categories: [...CLIENTS_DATA.categories, updateNewCategory]
                    }));
                    dispatch(resetClientNewCategory()); // Reset new category
                    dispatch(postClientsSettings({
                        ...CLIENTS_DATA.clientsSettings,
                        categories: [...CLIENTS_DATA.categories, updateNewCategory]
                    }, {company: company.id, year: company.year}));
                    // toast.info("Please save the changes.");
                }

            }
            // If pressed enter
            if (e.key === "Enter") {
                if (data.field === 'category' && data.value === '') {
                    toast.error("Category name should not be empty.");
                } else {
                    let updateNewCategory = Object.assign({}, CLIENTS_DATA.newCategory);

                    if (data.field === 'category' && data.value !== '') {
                        updateNewCategory.category = data.value;
                    }

                    if (updateNewCategory?.category !== '') {
                        if (data.field === 'maskCode' && data.value !== '') {
                            const lastVal = getLastHighestValue(CLIENTS_DATA.categories, 'maskCodeCounter') + 1;
                            updateNewCategory.mask = getMaskCodePrefix(data.value) + '-' + leadingZeros(lastVal, 4);
                            updateNewCategory.maskCode = getMaskCode(data.value);
                            updateNewCategory.maskCodePrefix = getMaskCodePrefix(data.value);
                            updateNewCategory._id = getLastHighestValue(CLIENTS_DATA.categories, '_id') + 1;
                            updateNewCategory.maskCodeCounter = lastVal;
                        }
                        dispatch(setClientsSettings({
                            ...CLIENTS_DATA.clientsSettings,
                            categories: [...CLIENTS_DATA.categories, updateNewCategory]
                        }));
                        dispatch(resetClientNewCategory()); // Reset new category
                        dispatch(postClientsSettings({
                            ...CLIENTS_DATA.clientsSettings,
                            categories: [...CLIENTS_DATA.categories, updateNewCategory]
                        }, {company: company.id, year: company.year}));
                        // toast.info("Please save the changes.");

                    } else {
                        toast.error("Category name should not be empty.");
                    }
                }
            }
        },
        selected: (data) => {
            if (data && typeof (data._id) !== 'undefined') {
                const selected = getObjectFromArrayOfObjects(CLIENTS_DATA.categories, data._id, '_id');
                if (selected && selected.length > 0) {
                    dispatch(setSelectedClientCategory(selected['0']));
                }
            }
        },

        update: (data, id) => {
            if (data.category) {
                toast.error("Το όνομα δεν γίνεται να τροποποιηθεί.");
            } else {
                let tempCategoryData = CLIENTS_DATA.categories.slice();
                if (tempCategoryData) {
                    const objindx = tempCategoryData.findIndex(obj => obj._id === id);
                    let catObj = tempCategoryData[objindx];
                    let titleMatch = (data.maskCode === catObj.maskCode);
                    let tempUpdateObj = {...catObj, ...data}
                    tempUpdateObj._id = id;
                    if (data?.maskCode === '') {
                        toast.error('Mask code should not be empty.');
                    } else if (data.maskCode && data.maskCode !== '') {
                        tempUpdateObj.mask = getMaskCodePrefix(data.maskCode) + '-' + leadingZeros(tempUpdateObj.maskCodeCounter, 4);
                        tempUpdateObj.maskCode = getMaskCode(data.maskCode);
                        tempUpdateObj.maskCodePrefix = getMaskCodePrefix(data.maskCode);
                    }
                    if (!titleMatch) {
                        tempCategoryData[objindx] = tempUpdateObj;
                        dispatch(setClientsSettings({...CLIENTS_DATA.clientsSettings, categories: tempCategoryData}));
                        dispatch(setEditing(true));
                        dispatch(postClientsSettings({
                            ...CLIENTS_DATA.clientsSettings,
                            categories: tempCategoryData
                        }, {company: company.id, year: company.year}));
                        // toast.info("Please save the changes.");
                    }
                }
            }
        },
        delete: () => {}
    }
    const handleAccountingChange = (e) => {
        if (!ACTIVITY.editing) dispatch(setEditing(true));
        const name = e.target.name;
        const value = e.target.value;
        dispatch(setSelectedClientCategory({...selectedCategory, [name]: value}));

        let cloneCategories = CLIENTS_DATA.clientsSettings.categories.slice();
        cloneCategories = cloneCategories.map((a) => Object.assign({}, a));
        let idx = cloneCategories?.findIndex((el) => el._id === selectedCategory._id);
        if (idx !== -1) {
            cloneCategories[idx][name] = value;
            dispatch(setClientsSettings({...CLIENTS_DATA.clientsSettings, categories: cloneCategories}));
        }
    }
    const handleApplyToAll = () => {
        setLoadingApplyToAll(true);
        axios.post(process.env.REACT_APP_API_URL2 + "/client/apply-accounting-settings-to-all", {
            company: company.id,
            category: selectedCategory.category,
            accounting: selectedCategory?.accounting ? selectedCategory.accounting : "",
            bypassAccounting: selectedCategory?.bypassAccounting ? selectedCategory.bypassAccounting : "",
        }, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            setLoadingApplyToAll(false);
            if (res.data.status === "200") {
                toast.success("Η διαδικασία ολοκληρώθηκε επιτυχώς.");
                setShowApplyToAll(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoadingApplyToAll(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }
    return (
        <div className="client-settings">
            <div className="row">
                <div className="col-lg-6">
                    <EditableTable
                        tableName="Client Category" // Do not change name
                        selectedRow={selectedCategory._id}
                        onUpdate={parentActions}
                        key={Math.random()}
                        allowActions={false}
                        allowInsertRow={false}
                        data={CLIENTS_DATA.categories && CLIENTS_DATA.categories.length > 0 ? getObjectFromArrayOfObjects(CLIENTS_DATA.clientsSettings.categories, 'active', 'isActive') : clientsCategoryData}  // Default Category
                        columns={clientsColumns}
                    />
                </div>
                <div className="col-lg-6 ">
                    <p className="text-muted"><i>{t('ClientsSettings.instructions')}</i></p>
                    <p>{t('ClientsSettings.instructionsCategoryName')}</p>
                    <p>{t('ClientsSettings.instructionsCodeMask')}</p>
                    {(selectedCategory.category && checkPermission("clients-clients/new-accounting-write", permissionsData)) && (
                        <React.Fragment>
                            <hr/>
                            <p className="text-muted"><i>Λογιστική κατηγορίας {selectedCategory.category}</i></p>
                            <Row>
                                <Col md={6}>
                                    <Input
                                        name={"accounting"}
                                        className="mb-3"
                                        charLimit={20}
                                        placeholder="Εισάγετε Πρόθεμα Κωδικού Λογαριασμού"
                                        label="Πρόθεμα Κωδικού Λογαριασμού"
                                        value={selectedCategory.accounting ? selectedCategory.accounting : ""}
                                        onChange={(e) => handleAccountingChange(e)}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Input
                                        name="bypassAccounting"
                                        className="mb-3"
                                        charLimit={20}
                                        placeholder="Εισάγετε Κωδικό Λογαριασμού Παράκαμψης"
                                        label="Κωδικός Λογαριασμού Παράκαμψης"
                                        value={selectedCategory.bypassAccounting ? selectedCategory.bypassAccounting : ""}
                                        onChange={(e) => handleAccountingChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Button onClick={() => setShowApplyToAll(true)}>Εφαρμογή Λογιστικής σε όλους τους πελάτες αυτής της κατηγορίας</Button>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                </div>
            </div>
            <hr/>
            <div className="row">
                <div className="col-12 col-lg-6">
                    <Input
                        className="mb-3"
                        label={t("ClientsSettings.googleCalendarApi")}
                        placeholder="API"
                        name="googleCalendarApi"
                        value={CLIENTS_DATA.clientsSettings.googleCalendarApi}
                        onChange={(e) => handleOnChange(e)}
                    />
                    <div className="client-communication mb-3">
                        <p className="text-muted"><i>{t('ClientsSettings.clientsCommunicationHistory')}</i></p>
                        <Input
                            label={t("ClientsSettings.subjectOptions.subjectOptions")}
                            placeholder={t("ClientsSettings.subjectOptions.placeholder")}
                            name="clientCommunicationHistory"
                            value={CLIENTS_DATA.clientsSettings.clientCommunicationHistory}
                            onChange={(e) => handleOnChange(e)}
                        />
                        <small>{t('ClientsSettings.instructionsSubject')}</small>
                    </div>
                </div>
                <div className="col-12 col-lg-6 ">
                    <p className="text-muted"><i>{t('ClientsSettings.clientInfoTabSettings')}</i></p>
                    {
                        CLIENTS_DATA.clientsSettings.clientsInfo &&
                        CLIENTS_DATA.clientsSettings.clientsInfo.length > 0 &&
                        CLIENTS_DATA.clientsSettings.clientsInfo.map((item, index) => {
                            return (
                                <div className="sectrow d-flex align-items-end justify-content-center" key={Math.random() + index}>
                                    <Input
                                        label={`Section ${index + 1}`}
                                        placeholder="Enter Section Label"
                                        name={index}
                                        value={item}
                                        disabled
                                        className="mb-3 w-100"
                                        onChange={(e) => handleOnClientInfoChange(e, index)}
                                    />
                                    <Popconfirm title="Are you sure? It will also delete the related information for this section." onConfirm={() => deleteInfoField(item, index)}>
                                        <span className="btn border-danger btn-sm mb-3 ml-2">
                                            <i className="fas text-danger fa-minus-circle"></i>
                                        </span>
                                    </Popconfirm>
                                </div>
                            )
                        })
                    }
                    <div className="d-flex align-items-end justify-content-center mb-3">
                        <Input
                            id="clientsInfo-input"
                            label={t('ClientsSettings.addNewSection.addNewSection')}
                            placeholder={t('ClientsSettings.addNewSection.placeholder')}
                            name="clientsInfo"
                            charLimit="30"
                            value={clientsInfoInput ? clientsInfoInput : ''}
                            onKeyDown={(e) => handeKeyDown(e)}
                            onChange={(e) => setInputToState(e)}
                        />
                        <label onClick={() => addInfoField()} className="btn btn-primary btn-sm m-0 ml-2"
                               htmlFor="clientsInfo-input">
                            <i className="fas fa-plus"></i>
                        </label>
                    </div>
                </div>
            </div>
            <Row>
                <Col md={12}>
                    <TagManager header={"Ετικέτες Πελατών"} tags={CLIENTS_DATA.clientsSettings.tags} setTags={(tags) => {
                        if (!ACTIVITY.editing) dispatch(setEditing(true));
                        dispatch(setClientsSettings({...CLIENTS_DATA.clientsSettings, tags}));
                    }} />
                </Col>
            </Row>
            <Modal backdrop={"static"} show={showApplyToAll} onHide={() => setShowApplyToAll(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Εφαρμογή Λογιστικής σε όλους του πελάτες</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <strong>Αποθηκεύστε τις ρυθμίσεις πρωτού ξεκινήσετε αυτήν την διαδικασία.</strong><br/>
                    Είσαστε σίγουροι ότι θέλετε να εφαρμόσετε τις τωρινές ρυθμίσεις λογιστικής σε όλους τους πελάτες της κατηγορίας {selectedCategory.category};<br/>
                    Συγκεκριμένα θα τοποθετηθεί:<br/>
                    - Πρόθεμα Κωδικού λογαριασμού: {selectedCategory?.accounting ? selectedCategory.accounting : "Κενό"}<br/>
                    - Πρόθεμα Λογαριασμού παράκαμψης: {selectedCategory?.bypassAccounting ? selectedCategory.bypassAccounting : "Κενό"}<br/>
                    Η διαδικασία μπορεί να πάρει λίγο χρόνο.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowApplyToAll(false)}>Όχι, κλείσιμο</Button>
                    <Button variant="primary" onClick={() => handleApplyToAll()} disabled={loadingApplyToAll}>Ναι, εφαρμογή σε όλους {loadingApplyToAll && <Spinner animation="border" variant="dark" />}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export const ClientSettingsLog = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.clientSettingsLog')}</i></div>
            <LogTable model="clientSetting"/>
        </React.Fragment>
    )
};

export default ClientsSettings;
